import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpEmergingRegionsKeys = {
  all: ['analytics', 'fp-emerging-regions'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpEmergingRegionsKeys.all, 'list', params] as const,
};

export const useFPEmergingRegionsData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpEmergingRegionsKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPEmergingRegions(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
